import { render, staticRenderFns } from "./HomeLayout.vue?vue&type=template&id=21cc691c&scoped=true"
import script from "./HomeLayout.vue?vue&type=script&lang=js"
export * from "./HomeLayout.vue?vue&type=script&lang=js"
import style0 from "./HomeLayout.vue?vue&type=style&index=0&id=21cc691c&prod&lang=css"
import style1 from "./HomeLayout.vue?vue&type=style&index=1&id=21cc691c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21cc691c",
  null
  
)

export default component.exports